export default function Rating(theme) {
  return {
    MuiRating: {
      styleOverrides: {
        root: {
          '& .MuiRating-iconFilled': {
            color: theme.palette.warning?.main || '#FF9800',
          },
          '& .MuiRating-iconHover': {
            color: theme.palette.warning?.light || '#FFB74D',
          },
          '& .MuiRating-iconEmpty': {
            color: theme.palette.grey[300],
          },
        },
      },
    },
  };
}

